import type { IncidentUpdate } from "../../types/incidents";

interface IncidentTimelineProps {
  updates: IncidentUpdate[];
}

export function IncidentTimeline({ updates }: IncidentTimelineProps) {
  const sorted = [...updates].sort(
    (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );

  return (
    <ol className="aptean-incident-timeline" aria-label="Incident updates">
      {sorted.map((update, index) => {
        const isLatest = index === sorted.length - 1;
        return (
          <li
            key={update.id}
            className={`aptean-incident-timeline__entry${isLatest ? " aptean-incident-timeline__entry--latest" : ""}`}
          >
            <time
              className="aptean-incident-timeline__timestamp"
              dateTime={update.created_at}
            >
              {new Date(update.created_at).toLocaleString()}
            </time>
            <span className="aptean-incident-timeline__author">
              {update.created_by}
            </span>
            <p className="aptean-incident-timeline__message">{update.message}</p>
          </li>
        );
      })}
    </ol>
  );
}
